import { IconBuilding, IconChevronDown } from 'components/icons';
import {
  ApartmentOutput,
  CommercialAreaOutput,
  ProjectEnumType,
  TownhouseOutput,
} from 'graphql/main/queries';
import { useTranslation } from 'hooks';
import { includes, isNil, map, toString } from 'lodash';
import { DetailProjectPageContext } from 'pages/du-an/[chi-tiet-du-an]';
import { useContext, useState } from 'react';
import RealEstateInformation, { RealEstateType } from './real-estate-information';

interface RealEstatesByType {
  type?: RealEstateType;
  realEstates?: TownhouseOutput[] | ApartmentOutput[] | CommercialAreaOutput[];
  translateQuantity?: string;
  quantity?: number;
}

const RealEstateInProject = () => {
  const translate = useTranslation();
  const { project } = useContext(DetailProjectPageContext).pageData ?? {};
  const { project: projectDetail } = project ?? {};
  const {
    apartment,
    independentVilla,
    townhouse,
    doubleVilla,
    shophouse,
    condotel,
    offictel,
    penthouse,
    commercialArea,
    apartmentCount,
    independentVillaCount,
    townhouseCount,
    doubleVillaCount,
    shopHouseCount,
    condotelCount,
    offictelCount,
    penthouseCount,
    commercialAreaCount,
    projectType,
  } = projectDetail ?? {};
  const [isExpandAccordion, setExpandAccordion] = useState(true);
  const isShowRealEstateInformation = includes(
    [ProjectEnumType.complex, ProjectEnumType.socialHouse],
    projectType,
  );
  const realEstatesTypes: RealEstatesByType[] = [
    {
      type: 'apartment',
      translateQuantity: 'apartmentCount',
      realEstates: apartment,
      quantity: apartmentCount,
    },
    {
      type: 'townhouse',
      translateQuantity: 'townhouseCount',
      realEstates: townhouse,
      quantity: townhouseCount,
    },
    {
      type: 'independentVilla',
      translateQuantity: 'independentVillaCount',
      realEstates: independentVilla,
      quantity: independentVillaCount,
    },
    {
      type: 'doubleVilla',
      translateQuantity: 'doubleVillaCount',
      realEstates: doubleVilla,
      quantity: doubleVillaCount,
    },
    {
      type: 'shophouse',
      translateQuantity: 'shopHouseCount',
      realEstates: shophouse,
      quantity: shopHouseCount,
    },
    {
      type: 'condotel',
      translateQuantity: 'condotelCount',
      realEstates: condotel,
      quantity: condotelCount,
    },
    {
      type: 'offictel',
      translateQuantity: 'offictelCount',
      realEstates: offictel,
      quantity: offictelCount,
    },
    {
      type: 'penthouse',
      translateQuantity: 'penthouseCount',
      realEstates: penthouse,
      quantity: penthouseCount,
    },
    {
      type: 'commercialArea',
      translateQuantity: 'commercialAreaCount',
      realEstates: commercialArea,
      quantity: commercialAreaCount,
    },
  ];

  const toggleExpandAccordion = () => {
    setExpandAccordion(!isExpandAccordion);
  };

  return isShowRealEstateInformation ? (
    <section id='real-estate-in-project' className='rounded-[16px] bg-paper p-[24px] shadow-7'>
      <div className='flex justify-between'>
        <div className='flex items-center'>
          <div className='flex h-[30px] w-[30px] items-center justify-center rounded-[8px] bg-background'>
            <IconBuilding className='h-[18px] w-[18px]' />
          </div>
          <h2 className='ml-[8px] text-[18px] font-[600] leading-[23px]'>
            {translate.desktop.detailProject.realEstatesInProject}
          </h2>
        </div>
        <div
          className='flex cursor-pointer select-none items-center text-primary'
          onClick={toggleExpandAccordion}
        >
          <span className='text-[12px] leading-[15px]'>
            {isExpandAccordion ? 'Ẩn bớt' : 'Xem thêm'}
          </span>
          <IconChevronDown
            className={`ml-[6px] h-[15px] w-[15px] font-[800] ${
              isExpandAccordion && 'rotate-180'
            } duration-[200ms]`}
          />
        </div>
      </div>
      <div
        className={`${
          isExpandAccordion ? 'max-h-fit' : 'max-h-0'
        } m-[-24px] space-y-[24px] overflow-hidden p-[24px]`}
      >
        <ul className='mx-[-8px] my-[8px] flex flex-wrap'>
          {map(realEstatesTypes, (realEstatesType, realEstatesTypeIndex) =>
            !isNil(realEstatesType.quantity) ? (
              <li
                key={`real-estate-type-count-${realEstatesTypeIndex}`}
                className='w-full px-[8px] pt-[16px] lg:basis-1/2'
              >
                <div className='flex pb-[6px]'>
                  <div className='min-w-[180px]'>
                    <span className='font-[600]'>{`${
                      (translate.desktop.detailProject as any)[
                        toString(realEstatesType.translateQuantity)
                      ]
                    }`}</span>
                  </div>
                  <span className='block flex-1 text-center'>{realEstatesType.quantity}</span>
                </div>
                <div className='w-full border-b border-stroke' />
              </li>
            ) : null,
          )}
        </ul>
        <div className='space-y-[30px]'>
          {map(realEstatesTypes, (realEstatesType, realEstatesTypeIndex) => (
            <RealEstateInformation
              key={realEstatesTypeIndex}
              realEstates={realEstatesType.realEstates}
              type={realEstatesType.type}
            />
          ))}
        </div>
      </div>
    </section>
  ) : null;
};

export default RealEstateInProject;
